import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <footer class="bg-slate-50 text-center text-sm fixed bottom-0 left-0 right-0 border-t border-slate-200 z-40">
      <div class="py-3 px-4 flex items-center justify-center gap-2 flex-wrap">
        <img src="images/logo-wsv1850.png"
             alt="Logo WSV 1850 e.V."
             class="w-[50px] h-[30px] object-contain" />
        <span class="text-slate-700">Untergliederung</span>
        <a routerLink="/impressum" class="text-slate-900 hover:text-slate-600 font-medium">
          Impressum
        </a>
      </div>
    </footer>
  `
})
export class Footer {
}
